import { render, staticRenderFns } from "./GRoundTag.vue?vue&type=template&id=3d20c043&scoped=true&"
import script from "./GRoundTag.vue?vue&type=script&lang=ts&"
export * from "./GRoundTag.vue?vue&type=script&lang=ts&"
import style0 from "./GRoundTag.vue?vue&type=style&index=0&id=3d20c043&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3d20c043",
  null
  
)

export default component.exports